import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Intervention from "./components/Intervention";
import Signes from "./components/Signes";
import Marques from "./components/Marques";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";
import Avis from "@/components/feature/Avis";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";

export default function ElectrificationNicePage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Électrification Volet Roulant Strasbourg | Nice"
        description="Électrification volet roulant Nice à Strasbourg et dans le Bas-Rhin. Moteurs Era et Roll, radio OXIBD, sans changer le tablier, devis gratuit. 03 74 47 32 40."
        path="/electrification-nice"
        type="service"
        serviceType="Électrification de volet roulant Nice"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Électrification Nice" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Électrification Nice" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Intervention />
        <Signes />
        <Marques />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}